import classNames from 'classnames/bind';
import { Widget } from '@creditsights/styleguide-web';
import { uniqWith } from 'lodash';
import React from 'react';
import { WIDGET_ID } from '../../../pages/Article/Article.constants';
import { NO_PUBLIC_DOCUMENTS_AVAILABLE } from './RelatedDocumentsWidget.constants';
import styles from './RelatedDocumentsWidget.module.scss';
import { Component } from '../../../models';

const cx = classNames.bind(styles);
interface RelatedDocumentsWidgetProps {
  relatedDocuments: Component[];
}

const RelatedDocumentsWidget = ({ relatedDocuments }: RelatedDocumentsWidgetProps): React.ReactElement | null => {
  const renderDocuments = () =>
    uniqWith(relatedDocuments, (document) => document.title === NO_PUBLIC_DOCUMENTS_AVAILABLE && !document.file).map(
      (document) => {
        if (document.title === NO_PUBLIC_DOCUMENTS_AVAILABLE && !document.file) {
          return <span className={cx('private-document')}>{document.title}</span>;
        }

        return (
          <a
            href={document.file?.url || document.body || ''}
            className={cx('link')}
            rel="noopener noreferrer"
            target="_blank"
          >
            {document.title}
          </a>
        );
      }
    );

  return (
    <Widget headerTitle="Related Documents" fixedHeight dataTestId={WIDGET_ID.RELATED_DOCUMENTS}>
      <div className={cx('body')}>{renderDocuments()}</div>
    </Widget>
  );
};

export default RelatedDocumentsWidget;
